import script from "./accountInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./accountInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./accountInfoModal.vue?vue&type=style&index=0&id=bbed69a6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbed69a6"]])

export default __exports__